import { render, staticRenderFns } from "./WaterfallCard.vue?vue&type=template&id=348f0e45&scoped=true"
import script from "./WaterfallCard.vue?vue&type=script&lang=js"
export * from "./WaterfallCard.vue?vue&type=script&lang=js"
import style0 from "./WaterfallCard.vue?vue&type=style&index=0&id=348f0e45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f0e45",
  null
  
)

export default component.exports